import { debug, utils } from 'lib';
import { UiToast } from 'components';
import heartbeatPkLib from '../heartbeat-pk';

import forEach from 'lodash/forEach';

const log = debug.create('heartbeatPk');

const handle = (socket) => {
  socket.on('punish.pk.first', (msg, { room }) => {
    room.update();
    heartbeatPkLib.loadInfo();
  });

  socket.on('punish.pk.second', (msg) => {
    heartbeatPkLib.loadInfo();
  });

  socket.on('punish.pk.third', (msg) => {
    heartbeatPkLib.loadInfo();
  });

  socket.on('punish.pk.fourth', (msg, { room }) => {
    room.update();
    heartbeatPkLib.loadInfo();
  });
  socket.on('punish.voice_switch', (msg, { room }) => {
    room.update();
  });
  // {
  // 			"duration":当前阶段持续时间
  // 			"value": 主播更新之后的pk值
  // 		}
  socket.on(
    'punish.pk.star_value_update',
    (msg, { lianmai: { heartbeatPk } }) => {
      heartbeatPk.info.mode_info.updatePkValue(
        msg.data.room_id,
        msg.data.pk_value,
      );
      // heartbeatPkLib.loadInfo()
    },
  );
  // {
  // 			"duration":当前阶段持续时间
  // 			"list": 数组对象
  // 					{
  // 						uid  用户id
  // 						pic 用户头像
  // 						value  用户贡献值
  // 					}
  // 		}
  socket.on(
    'punish.pk.user_rank_update',
    (msg, { lianmai: { heartbeatPk } }) => {
      heartbeatPk.info.mode_info.updateTopUser(
        msg.data.room_id,
        msg.data.top_user,
      );
      // heartbeatPkLib.loadInfo()
    },
  );

  // {
  //   "action": "punish.pk.content_set",
  //   "data": {
  //     "100000004": "321"
  //   }
  // }

  socket.on(
    'punish.pk.content_set',
    (msg, { room, lianmai: { heartbeatPk } }) => {
      forEach(msg.data, (val, key) => {
        heartbeatPk.info.mode_info
          .getRoomPkInfo(parseInt(key, 10))
          ?.setPunishContent(val);
      });
    },
  );

  socket.on(
    'punish.pk.match_tips',
    (msg, { room, lianmai: { heartbeatPk } }) => {
      log('match_tips', heartbeatPk.info.toJSON(), room.roomInfo.toJSON());

      UiToast.text('目前暂无匹配主播，请耐心等待或取消匹配');

      heartbeatPkLib.loadInfo();
    },
  );
  socket.on(
    'punish.pk.match_cancel',
    (msg, { room, lianmai: { heartbeatPk } }) => {
      log('match_cancel', heartbeatPk.info.toJSON(), room.roomInfo.toJSON());

      UiToast.text(msg.data.msg || '匹配已取消');

      heartbeatPkLib.loadInfo();
    },
  );
};

export default handle;
